/**
 *
 *
 *
 *
 *
 *
 */
import type { Viewport } from "../globals/viewport.js";
import { otto } from "./nexus.js";
import type { OttoNexus } from "./nexus.js";

const viewport: OttoNexus["viewport"] = otto.viewport;

export * from "../lib/viewport/index.js";

/**
 *
 *
 *
 *
 *
 */
export const currentBreakpoint: Viewport["currentBreakpoint"] = viewport.currentBreakpoint;

/**
 *
 *
 *
 *
 */
export const isActiveBreakpoint: Viewport["isActiveBreakpoint"] = viewport.isActiveBreakpoint;

/**
 *
 *
 *
 */
export const getCurrentBreakpoint: Viewport["getCurrentBreakpoint"] = viewport.getCurrentBreakpoint;

/**
 *
 *
 *
 */
export const currentOrientation: Viewport["currentOrientation"] = viewport.currentOrientation;

/**
 *
 *
 */
export const isActiveOrientation: Viewport["isActiveOrientation"] = viewport.isActiveOrientation;

/**
 *
 */
export const getCurrentOrientation: Viewport["getCurrentOrientation"] =
  viewport.getCurrentOrientation;

/**
 *
 *
 */
export const getScrollbarWidth: Viewport["getScrollbarWidth"] = viewport.getScrollbarWidth;
